import type { KeyTextField } from '@prismicio/client';
import { memo } from 'react';
import styles from './helocTitle.module.scss';

interface HelocTitleProps {
  isActive: boolean;
  title: KeyTextField;
}

const HelocTitleComponent = ({ isActive, title }: HelocTitleProps) => {
  return (
    <li
      className={`${styles.title} ${isActive ? styles.visible : styles.hidden}`}
    >
      <h1>{title}</h1>
    </li>
  );
};

export const HelocTitle = memo(HelocTitleComponent);
